// extracted by mini-css-extract-plugin
export var clickThrough = "_xu-2";
export var fallback = "_xu-5";
export var frame = "_xu-3";
export var frameCell = "_xu-1";
export var overlay = "_xu-4";
export var wrapper = "_xu-0";